/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, action: NonNullable<unknown> }} Seo_Endpoint_Q_SubscriptionInputs */

const en_seo_endpoint_q_subscription = /** @type {(inputs: Seo_Endpoint_Q_SubscriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Do I need a subscription for the ${i?.name} ${i?.action} API?`)
};

const zh_hans1_seo_endpoint_q_subscription = /** @type {(inputs: Seo_Endpoint_Q_SubscriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`使用 ${i?.name} ${i?.action} API 需要订阅吗？`)
};

const pt_br2_seo_endpoint_q_subscription = /** @type {(inputs: Seo_Endpoint_Q_SubscriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preciso de assinatura para o endpoint ${i?.action} da API para ${i?.name}?`)
};

const es_seo_endpoint_q_subscription = /** @type {(inputs: Seo_Endpoint_Q_SubscriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Necesito una suscripción para el endpoint ${i?.action} de la API de ${i?.name}?`)
};

const fr_seo_endpoint_q_subscription = /** @type {(inputs: Seo_Endpoint_Q_SubscriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ai-je besoin d’un abonnement pour l’API ${i?.name} ${i?.action} ?`)
};

const de_seo_endpoint_q_subscription = /** @type {(inputs: Seo_Endpoint_Q_SubscriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Brauche ich ein Abo für die ${i?.name}-${i?.action}-API?`)
};

const ru_seo_endpoint_q_subscription = /** @type {(inputs: Seo_Endpoint_Q_SubscriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Нужна ли подписка для API ${i?.name} ${i?.action}?`)
};

const it_seo_endpoint_q_subscription = /** @type {(inputs: Seo_Endpoint_Q_SubscriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mi serve un abbonamento per l'API ${i?.name} ${i?.action}?`)
};

/**
* | output |
* | --- |
* | "Do I need a subscription for the {name} {action} API?" |
*
* @param {Seo_Endpoint_Q_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_endpoint_q_subscription = /** @type {((inputs: Seo_Endpoint_Q_SubscriptionInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Endpoint_Q_SubscriptionInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_endpoint_q_subscription(inputs)
	if (locale === "pt-BR") return pt_br2_seo_endpoint_q_subscription(inputs)
	if (locale === "es") return es_seo_endpoint_q_subscription(inputs)
	if (locale === "fr") return fr_seo_endpoint_q_subscription(inputs)
	if (locale === "de") return de_seo_endpoint_q_subscription(inputs)
	if (locale === "ru") return ru_seo_endpoint_q_subscription(inputs)
	if (locale === "it") return it_seo_endpoint_q_subscription(inputs)
	return en_seo_endpoint_q_subscription(inputs)
});